import { render, staticRenderFns } from "./SalonPage.vue?vue&type=template&id=6df2def4&scoped=true"
import script from "./SalonPage.vue?vue&type=script&lang=js"
export * from "./SalonPage.vue?vue&type=script&lang=js"
import style0 from "./SalonPage.vue?vue&type=style&index=0&id=6df2def4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2def4",
  null
  
)

export default component.exports